module.exports = __webpack_public_path__ + "static/img/gpt43.78ed674f.png";